export const removePrefixFromExternalId = (externalId: string): string => {
  const parts = externalId.split('.')
  if (
    'process' === parts[0] ||
    'deliverableList' === parts[0] ||
    'deliverable' === parts[0] ||
    'task' === parts[0] ||
    'ticket' === parts[0]
  ) {
    return parts[parts.length - 1]
  }
  return externalId
}
